<template>
  <div
    v-if="showANSILayers || showCustomerLayers || showDRTLayers || showUSHRLayers || analyticsVisible"
    class="layers-wrapper"
  >
    <draggable
      v-if="oneToolToggle"
      v-model="layerButtons"
      ghost-class="ghost"
      @end.prevent="onEnd()"
    >
      <transition-group type="transition" name="flip-list">
        <b-row
          :id="element.name"
          no-gutters
          class="layer-row"
          :class="[getLayerColClass(index, element), highlightTopLayer(index)]"
          :disabled="checkLayerDisable(element.name, element.zoomControl, element.minZoom)"
          v-for="(element, index) in layerButtons"
          :key="element.name"
          @click="$emit('getLegend', element.name)"
        >
          <!-- Layer name -->
          <b-col
            :cols="thresholdExists ? 8 : 8"
            class="layer-btn"
            @click="toggleLayer(element, $event)"
          >
            {{ element.display_name ? element.display_name 
                : element.name }}
            <b-spinner
              v-if="spinnerManager.includes(element.name)"
              variant="primary"
              small
              class="spinner-custom-position"
            ></b-spinner>
          </b-col>

          <!-- Up-arrow + filter icons -->
          <b-col
            :cols="thresholdExists ? 4 : 4"
            class="layer-arrow"
            :class="{ 'layer-arrow--end': drtLayersToggle }"
          >
            <fa
              @click="toTopOfList(element.display_name ? element.display_name : element.name)"
              title="Move Layer To Top"
              :icon="['fas', 'long-arrow-alt-up']"
              class="cursor"
            />
            <fa
              v-if="(drtLayersToggle || ansiLayersToggle) && globalIsUserAllowed('Filter_Modal')"
              :disabled="isLayerFilterDisabled"
              :id="`icon${index}`"
              @click="$emit('getFilterModal', { layer: element.name, id: `icon${index}` })"
              title="Layer Filter"
              :icon="['fas', 'filter']"
              :class="[filterClasses[index], { 'disabled-icon': isLayerFilterDisabled }]"
            />
            <div
              v-if=" thresholdExists && element.positionThreshold"
              class="cursor circle"
              :class="[
                { 'disabled': checkLayerDisable(element.name, element.zoomControl, element.minZoom) },
                { 'activated': element.positionThreshold.some(layerName => mmp_layersObj[layerName] && checkLayer(mmp_layersObj[layerName].layer)) }
              ]"
              @click="toggleThreshold(element.positionThreshold, $event)"
              title="Position Threshold"
            >P</div>
            <div
              v-if="thresholdExists && element.typeThreshold"
              class="cursor circle"
              :class="[
                { 'disabled': checkLayerDisable(element.name, element.zoomControl, element.minZoom) },
                { 'activated': element.typeThreshold.some(layerName => mmp_layersObj[layerName] && checkLayer(mmp_layersObj[layerName].layer)) }
              ]"
              @click="toggleThreshold(element.typeThreshold, $event)"
              title="Type Change Threshold"
            >T</div>
          </b-col>

          <!-- Threshold circles -->
          <!-- <b-col cols="2" class="layer-threshold" v-if="thresholdExists">
            <div
              v-if="element.positionThreshold"
              class="cursor circle"
              :class="[
                { 'disabled': checkLayerDisable(element.name, element.zoomControl, element.minZoom) },
                { 'activated': element.positionThreshold.some(layerName => mmp_layersObj[layerName] && checkLayer(mmp_layersObj[layerName].layer)) }
              ]"
              @click="toggleThreshold(element.positionThreshold, $event)"
              title="Position Threshold"
            >P</div>
            <div
              v-if="element.typeThreshold"
              class="cursor circle"
              :class="[
                { 'disabled': checkLayerDisable(element.name, element.zoomControl, element.minZoom) },
                { 'activated': element.typeThreshold.some(layerName => mmp_layersObj[layerName] && checkLayer(mmp_layersObj[layerName].layer)) }
              ]"
              @click="toggleThreshold(element.typeThreshold, $event)"
              title="Type Change Threshold"
            >T</div>
          </b-col> -->
        </b-row>
      </transition-group>
    </draggable>
  </div>
</template>

<style scoped>
/* ── Scroll container ── */
.layers-wrapper {
  background-color: #ffffff;
  flex: 0 0 auto;
  width: 100%;
  /* max-width: 290px; */
  min-height: 0;
  overflow-y: auto;
  /* border-radius: 10px; */
  box-shadow: 0 2px 10px rgba(6, 60, 109, 0.12);
}

/* ── Row ── */
.layer-row {
  padding: 0 !important;
  width: 100%;
  height: 42px;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(6, 60, 109, 0.08);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.layer-row:hover {
  background-color: rgba(6, 60, 109, 0.05);
  cursor: pointer;
}

/* ── Layer name cell ── */
.layer-btn {
  font-size: 13px !important;
  font-weight: 200;
  text-shadow: none !important;
  height: 100%;
  padding: 12px 12px !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #063c6d;
  position: relative;
  transition: color 0.2s ease;
}

/* ── Icon cell (up-arrow + filter) ── */
.layer-arrow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  color: #063c6d;
  cursor: pointer;
}
.layer-arrow--end {
  justify-content: flex-end;
  padding-right: 12px;
}

/* ── Threshold circle cell ── */
.layer-threshold {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

/* ── Status indicators (white base, subtle accents) ── */
.available-not-enabled {
  background-color: #ffffff;
}
.available-enabled {
  background-color: #b8e7ca;
  box-shadow: inset 3px 0 0 #1f9d55;
}
.available-enabled:hover {
  background-color: #b8e7ca;
}
.unavailable {
  background-color: #dfe1e2;
}
.unavailable .layer-btn,
.unavailable .layer-arrow {
  color: rgba(7, 23, 39, 0.4);
}
.unavailable:hover {
  background-color:  #dfe1e2;
}

/* ── Keyboard-navigation highlights ── */
/* .highlightTopLayer {
  box-shadow: inset 0 0 0 2px rgba(6, 60, 109, 0.25);
} */
.highlightCurrentLayer {
  box-shadow: inset 0 0 0 2px #007BFF;
}

/* ── Threshold circles ── */
.circle {
  border: 1px solid #063c6d;
  border-radius: 50%;
  height: 22px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: #063c6d;
}
.activated {
  border-color: #007bff !important;
  color: white !important;
  background: #007bff;
}
.disabled {
  opacity: 0.7;
  pointer-events: none;
}

/* ── Misc ── */
.cursor {
  cursor: pointer;
}
.orange-font {
  color: orange !important;
}
.spinner-custom-position {
  position: absolute;
  right: 8px;
}
.disabled-icon {
  pointer-events: none;
  opacity: 0.5;
}
</style>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex';
import {orderMapLayers} from '../../../utils/utils.js'
import {unByKey} from 'ol/Observable'
export default {
  name: 'MMP_DynamicLayerList',
  components: {
    draggable
  },
  props: [
    'analyticsVisible',
    'wclLayersButtonsCtrl',
    'ansiLayersButtonCtrl',
    'ansiLayersToggle',
    'customerLayersButtonsCtrl',
    'customerLayersToggle',
    'customerProjectId',
    'cust_layersObj',
    'drtLayersButtonsCtrl',
    'drtLayersToggle',
    'filterClassesObj',
    'layerResponse',
    'map',
    'mmp_layersObj',
    'otonomoSubcountry',
    'rules',
    'selectAllControl',
    'showANSILayers',
    'showCustomerLayers',
    'showDRTLayers',
    'showUSHRLayers',
    'spinnerManager',
    'ushrLayersButtonsCtrl',
    'ushrLayersToggle',
    'zoomEnded',
    'zoomLevelCap',
    'layerDefinition',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen',
    'user'
  ],
  data() {
    return {
      layerButtons: [],
      filterClasses: [],
      oneToolToggle: true,
      currentIndex: 0,
      isLayerFilterDisabled: false
    }
  },
  methods: {
    capitalizeFirstLetter(str) {
      if (!str) return ""; // Handle empty strings safely
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    checkAllToolToggles() {
      this.oneToolToggle =
        this.ansiLayersToggle ||
        this.customerLayersToggle ||
        this.drtLayersToggle ||
        this.ushrLayersToggle
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] === layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name === layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    custLayerToggle(layerNameToToggle) {
      if (this.cust_layersObj[layerNameToToggle] != null) {
        let layerobj = this.cust_layersObj[layerNameToToggle].layer
        if (this.checkLayer(layerobj)) {
          this.map.removeLayer(layerobj)
          this.$emit('showCustomerLayer', false)
        } else {
          this.map.addLayer(layerobj)
          this.$emit('showCustomerLayer', true)
        }
      }
    },
    getLayerColClass(index, element) {
      let retVal = 'col col-no-pad py-1  '
      if (element.name != 'OSM') {
        let mapObjs =
          this.cust_layersObj != undefined
            ? this.cust_layersObj
            : this.mmp_layersObj
        let disabled = this.checkLayerDisable(
          element.name,
          element.zoomControl,
          element.minZoom
        )
        let displaying = this.checkLayer(mapObjs[element.name].layer)

        if (!disabled && displaying) {
          // Layer isn't disabled and layer is turned on
          retVal += ' available-enabled'
        } else if (!disabled) {
          // Layer isn't disabled and layer is turned off
          retVal += ' available-not-enabled'
        } else {
          // Layer is disabled
          retVal += ' unavailable'
        }
      } else {
        this.map.getLayers().forEach(layer => {
          if (layer != undefined && layer.get('name') != undefined) {
            if (layer.get('name').includes('OSM')) {
              retVal += ' available-enabled'
              //   retVal = 'btn capitalize cursor vert-align py-2 btn-secondary btn-sm col col-no-pad py-1 available-enabled'
            } else {
              retVal += ' available-not-enabled'
              // retVal= 'btn capitalize cursor vert-align py-2 btn-secondary btn-sm col col-no-pad py-1   available-not-enabled'
            }
          }
        })
      }
      return retVal
    },
    initFilterClasses() {
      let tempFilterClasses = []
      for (let i in this.layerButtons) {
        let layerName = this.layerButtons[i].name
        let objToPush = {
          cursor: true,
          hover: false,
          sortable: true
        }
        for (let rule in this.rules) {
          if (this.rules[rule].layer == layerName) {
            objToPush['orange-font'] = true
            break
          }
        }
        tempFilterClasses.push(objToPush)
      }
      this.filterClasses = tempFilterClasses
    },
    checkLayerDisable(layerName, zoomControl, minZoom) {
      /* checkLayerDisable method returns true if zoomControl is
      enabled and the user is zoomed in far enough. */
      this.$emit('updateZoomEnded', this.map.getView().getZoom())
      let returnClass = false
      let isANSILayer = ['ANSI', 'random_segments'].includes(layerName)
      let allowedANSI = [5, 22].includes(parseInt(this.customerProjectId))
      let layerExists = this.mmp_layersObj[layerName] != null
      let showLayer =
        minZoom == null
          ? this.zoomEnded >= this.zoomLevelCap
          : this.zoomEnded >= minZoom

      if ('Otonomo'.includes(layerName)) {
        /* returnClass is true if an Otonomo subcountry has been selected,
        zoomControl is enabled on the layer, and the user is zoomed in far enough. */
        returnClass = !(this.otonomoSubcountry && zoomControl && showLayer)
      } else if (layerExists && (!isANSILayer || allowedANSI)) {
        const layerObj = this.mmp_layersObj[layerName].layer
        if (!this.checkLayer(layerObj)) {
          /* returnClass is true if zoomControl is enabled on the
          layer and the user is zoomed in far enough. */
          returnClass = zoomControl && !showLayer
        }
      }

      return returnClass
    },
    async onEnd() {
      let mapObjs =
        this.cust_layersObj != undefined
          ? this.cust_layersObj
          : this.mmp_layersObj
      await orderMapLayers(mapObjs, this.layerButtons, this.map)
      let topLayerEnabled = false;
      this.map.getLayers().forEach(layer => {
        // If layer is on top and exists on map, reset attributes
        if (layer && layer.get('name') == this.layerButtons[0].name) {
          topLayerEnabled = true
          {
            this.$emit('loadAttributes', {
              name: this.layerButtons[0].name,
              layer_group: this.layerButtons[0].layer_group,
              response: this.layerResponse
            })
            this.$emit('getShowAttributes', false)
          }
        }
      })
      if (!topLayerEnabled) {
        this.$emit('removeLayerListener')
      }
      this.$emit('layerButtonsChanged', this.layerButtons)
      this.initFilterClasses()
    },
    toggleLayer(element, event) {
      let disabled = this.checkLayerDisable(
        element.name,
        element.zoomControl,
        element.minZoom
      )
      let layerName = element.name
      if (!disabled) {
        if (layerName == 'errors') {
          this.$emit('getErrorsLayer', this.mmp_layersObj['errors'].layer)
          this.$emit('toggleErrorsLayerVisibility')
        }
        this.$emit('toggleLayerVisibility', layerName)
        if (element.threshold) {
          this.toggleOffThreshold(element.threshold)
        }
        this.onEnd()
      }

      event.target.blur();
    },
    toggleOffThreshold(layers) {
      layers.forEach(layer => {
        if (this.checkLayer(this.mmp_layersObj[layer.layerName].layer)) {
          this.$emit('toggleLayerVisibility', layer.layerName)
        }
      })
    },
    toggleThreshold(thresholdLayers, event) {
      thresholdLayers.forEach((thresholdLayerName) => {
        let element = this.ansiLayersButtonCtrl.filter(layer => layer.name == thresholdLayerName)
        let disabled = this.checkLayerDisable(
          element.name,
          element.zoomControl,
          element.minZoom
        )
        if (!disabled) {
          this.$emit('toggleLayerVisibility', thresholdLayerName)
          this.onEnd()
        }
      })

      event.target.blur();
    },
    toTopOfList(elementName) {
      let tool
      if (this.ansiLayersToggle) {
        tool = 'ANSI'
      } else if (this.customerLayersToggle) {
        tool = 'CUSTOMER'
      } else if (this.drtLayersToggle) {
        tool = 'DRT'
      } else if (this.ushrLayersToggle) {
        tool = 'USHR'
      }

      return new Promise((resolve) => {
        this.$emit('toTopOfList', { payload: { layerName: elementName, tool }, resolve })
      }).then(() => {
        this.onEnd()
      })
    },
    highlightTopLayer(index) {
      return (
        'sortable menu-item item ' +
        (index == 0 ? (this.currentIndex == 0 ? ' highlightCurrentLayer' : ' highlightTopLayer') : this.highlightCurrentLayer(index))
      )
    },
    highlightCurrentLayer(index) {
      return this.currentIndex == index ? ' highlightCurrentLayer' : ''
    },
    keyDownHandler(event) {
      if (['input', 'b-form-textarea', 'b-form-input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
        return;
      }
      if (event.key === 'ArrowDown' && this.currentIndex < this.layerButtons.length - 1) {
        this.currentIndex++
        this.scrollToLayer(this.currentIndex)
      } else if (event.key === 'ArrowUp' && this.currentIndex > 0) {
        this.currentIndex--
        this.scrollToLayer(this.currentIndex)
      } else if (event.key == 'Enter') {
        let layer = this.layerButtons[this.currentIndex]
        this.toggleLayer(layer, event)
      }
    },
    scrollToLayer(index) {
      this.$nextTick(() => {
        let layer = document.getElementById(this.layerButtons[index].name) // get the layer element by its ID declared above
        if (layer) {
          layer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      })
    },
    removeIteratorListener() {
      window.removeEventListener('keydown', this.keyDownHandler)
    },
    addIteratorListener() {
      window.addEventListener('keydown', this.keyDownHandler)
    }
  },
  mounted() {
    if (this.ansiLayersToggle) {
      this.layerButtons = this.ansiLayersButtonCtrl
    } else if (this.customerLayersButtonsCtrl) {
      this.layerButtons = this.customerLayersButtonsCtrl
    } else if (this.drtLayersToggle) {
      this.layerButtons = this.drtLayersButtonsCtrl
    } else if (this.ushrLayersToggle) {
      this.layerButtons = this.ushrLayersButtonsCtrl
    } else if (this.analyticsVisible) {
      this.layerButtons = this.wclLayersButtonsCtrl
    }

    this.addIteratorListener(),
    this.isLayerFilterDisabled = !this.globalIsUserAllowed('Filter_Modal')
  },
  beforeDestroy() {
    this.removeIteratorListener()
  },
  computed: {
    ...mapGetters(['globalUserRole','globalAllowedUserModules','globalIsUserAllowed']),
    thresholdExists() {
      return this.layerButtons.some(btn => !!btn.threshold);
    }
  },
  watch: {
    ansiLayersButtonCtrl: function (newValue, oldValue) {
      if (this.layerDefinition=='BIASED') {
          this.layerButtons = newValue.filter(e => e.layer_definition == 'BIASED')
      } else {
          this.layerButtons = newValue
      }
      this.initFilterClasses()
    },
    ansiLayersToggle: function (newValue, oldValue) {
      this.checkAllToolToggles()
    },
    customerLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
    },
    customerLayersToggle: function (newValue, oldValue) {
      this.checkAllToolToggles()
    },
    drtLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
      this.initFilterClasses()
    },
    drtLayersToggle: function (newValue, oldValue) {
      this.checkAllToolToggles()
    },
    filterClassesObj: function (newValue, oldValue) {
      Object.assign(this.filterClasses[newValue.index], newValue.passedClass)
      this.initFilterClasses()
    },
    otonomoSubcountry: function (newValue, oldValue) {
      this.onEnd()
    },
    ushrLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
    },
    ushrLayersToggle: function (newValue, oldValue) {
      this.checkAllToolToggles()
    },
    wclLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
      console.log(this.layerButtons)
      //this.initFilterClasses()
    },
    showLidarPanel: function(newValue) {
      if (this.baseMapsOpen) {
        this.removeIteratorListener()
      } else if (this.extentsOpen) {
        this.removeIteratorListener()
      } if (newValue) {
        this.removeIteratorListener()
      } else {
        this.addIteratorListener()
      }
    },
    baseMapsOpen: function(newValue) {
      if (newValue) {
        this.removeIteratorListener() 
      } else if (this.extentsOpen) {
        this.removeIteratorListener()
      } else if (this.showLidarPanel) {
        this.removeIteratorListener()
      } else {
        this.addIteratorListener()
      }
    },
    extentsOpen: function (newValue) {
      if (newValue) {
        this.removeIteratorListener()
      } else if (this.baseMapsOpen) {
        this.removeIteratorListener()
      } else if (this.showLidarPanel) {
        this.removeIteratorListener()
      } else {
        this.addIteratorListener()
      }
    },

  }
}
</script>
